/** @format */

var AbstractWS = require("./AbstractWS");

function EnterQueueWS(viewModel) {
  var self = this;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  this.successHandler = null;
  this.successHandlerArg = null;
  this.method("POST");
  this.name = "EnterQueueWS";

  /**
   * Overload of superclass method to call the API
   *
   * @method doRequest
   * @param {Function} fCallback
   * @returns none
   */
  this.doRequest = function (fCallback) {
    self.addParam("source", "CEC");

    self.serviceURL = ko.computed(function () {
      return (
        "/qless/api/v1/employee/queues/" + self.params["queueId"] + "/enter"
      );
    });

    AbstractWS.prototype.doRequest.call(self, fCallback);
  };

  /**
   * Handles return of API data
   *
   * @method processData
   * @param {Mixed} data
   * @returns none
   */
  this.processData = function (data) {
    var errMsg = null;

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, data, true);

    if (self.err) {
      window.vm.conlog(self.err);

      if (self.err.rootCauseType == "AlreadyQueuedException") {
        if (self.isLangUS()) {
          errMsg = self.parent.messagesWS.get("already.queued");
        } else {
          errMsg = self.errorMessage();
          if (!errMsg) {
            errMsg = "Already queued.";
          }
        }
        //enterQueueFailed.open();
        window.vm.conlog(errMsg);

        window.vm.errorMessage(errMsg);
        window.vm.showError(true);
        window.vm.addConsumerVM.unsetEnterState();
      }
    } else {
      if (self.successHandler) {
        self.successHandler(self.successHandlerArg);
      }
    }
  };

  /**
   * Method to return the object to it's initial state
   *
   * @method reset
   * @returns {EnterQueueWS}
   */
  this.reset = function () {
    self.clearParams();
    self.delegate = null;
    self.delegateArg = null;

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);

    return self;
  };

  // Self as API
  return self;
}

Object.setPrototypeOf(EnterQueueWS.prototype, AbstractWS.prototype);

/**
 *
 * @param {object} customProps
 */
EnterQueueWS.prototype.addParamCustomProps = function (customProps) {
  for (var prop in customProps) {
    if (Object.prototype.hasOwnProperty.call(customProps, prop)) {
      var val = customProps[prop];
      if (val) {
        this.addParam("custom_prop." + prop, val);
      }
    }
  }
};

/**
 * @type ConsumerParameters
 * @property {string} transactionId
 * @property {string} phone
 * @property {string} name
 * @property {string} notes
 */

/**
 *
 * @param {ConsumerParameters} consumer
 * @param {CallableFunction|undefined} callback
 */
EnterQueueWS.prototype.enterConsumer = function (consumer, queueId, callback) {
  this.addParam("queueId", queueId);
  this.addParam("name", consumer.name);
  this.addParam("phone", consumer.phone);

  if (consumer.notes) {
    this.addParam("notes", consumer.notes);
  }

  if (consumer.sessionId) {
    this.addParam("session", consumer.sessionId);
  }

  if (consumer.transactionId) {
    this.addParam("transactionType", consumer.transactionId);
  }

  if (consumer.customProps && consumer.customProps.length > 0) {
    this.addParamCustomProps(consumer.customProps);
  }

  if (consumer.locale) {
    this.addParam("locale", consumer.locale)
  }

  this.doRequest(callback)
};

module.exports = EnterQueueWS;
